import type { FC } from 'react';
import React from 'react';

export const PlayIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="11.5" fill="white" stroke="black" />
      <path
        d="M9.11923 17.4383L9.11916 17.4383C8.85811 17.6003 8.5 17.4181 8.5 17.0757V6.92427C8.5 6.58188 8.85811 6.39972 9.11916 6.56171L9.1192 6.56173L17.3014 11.6379L17.3018 11.6382C17.5657 11.8015 17.5666 12.1984 17.3013 12.3631L9.11923 17.4383Z"
        stroke="black"
      />
    </svg>
  );
};
